
	import { defineComponent } from "vue";

	const DefaultView = defineComponent({
		name: "DefaultView"
	});
	export default DefaultView;
